// Mock data for Orbit social platform (frontend-only prototype)

export const AVATARS = {
  arby: 'https://images.unsplash.com/photo-1772371272141-0fbd644b65c4',
  cosmo: 'https://images.unsplash.com/photo-1740252117027-4275d3f84385',
  nova: 'https://images.unsplash.com/photo-1740252117070-7aa2955b25f8',
  vega: 'https://images.unsplash.com/photo-1728577740843-5f29c7586afe',
  lyra: 'https://images.unsplash.com/photo-1688205598514-1f8b73fec8ea',
  orion: 'https://images.unsplash.com/photo-1772371272167-0117a6573d58',
};

export const ART = {
  hands: 'https://images.unsplash.com/photo-1536849460588-696219a9e98d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  surreal: 'https://images.unsplash.com/photo-1634986666676-ec8fd927c23d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  paint2: 'https://images.unsplash.com/photo-1532640331846-d2da5987c3ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  digital: 'https://images.unsplash.com/photo-1635322966219-b75ed372eb01?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  fine1: 'https://images.unsplash.com/photo-1564934304050-e9bb87a29c13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  fine2: 'https://images.unsplash.com/photo-1551506337-8076769496c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
};

export const CURRENT_USER = {
  name: 'Arby',
  handle: '_arxnyah',
  sign: 'aries',
  avatar: AVATARS.arby,
  tags: ['art', 'graphic design'],
  bio: 'art graphic design +',
  stats: { orbits: 537, cosmos: 214, relays: 1200 },
};

export const SONGS = [
  { id: 's1', title: 'Nobody Gets Me', artist: 'SZA', cover: 'https://images.unsplash.com/photo-1719930699151-ea588d6dc563?crop=entropy&cs=srgb&fm=jpg&q=85&w=400' },
  { id: 's2', title: 'Bring Me to Life', artist: 'Evanescence', cover: 'https://images.pexels.com/photos/8961542/pexels-photo-8961542.jpeg?auto=compress&w=400' },
  { id: 's3', title: 'Hotline Bling', artist: 'Drake', cover: 'https://images.pexels.com/photos/7135053/pexels-photo-7135053.jpeg?auto=compress&w=400' },
  { id: 's4', title: 'Mundo', artist: 'IV of Spades', cover: 'https://images.unsplash.com/photo-1683718522443-355f717f3b2a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400' },
];

export const GALAXY_TAGS = ['art', 'graphic design', 'photography', 'poetry', 'music', 'astronomy'];

export const PRIVACY_OPTIONS = ['Inner Orbit Only', 'Cosmos', 'Public Galaxy'];

export const FEELS = ['inspired', 'cosmic', 'sleepy', 'creative', 'lonely', 'grateful', 'hyped', 'calm'];

export const INITIAL_POSTS = [
  {
    id: 'p1', authorHandle: '_arxnyah', authorName: 'Arby', avatar: AVATARS.arby,
    time: '1 minute ago...', text: 'never give art to the wrong person.', image: ART.hands,
    galaxy: null, pinned: true, privacy: 'Cosmos',
    counts: { stars: 5, echoes: 3, relays: 7, rockets: 2 },
  },
  {
    id: 'p2', authorHandle: 'dev_cosmo', authorName: 'Cosmo', avatar: AVATARS.cosmo,
    time: '1 h', text: 'how it feels to edit with limited resources...', image: ART.surreal,
    galaxy: 'graphic design', pinned: false, privacy: 'Public Galaxy',
    counts: { stars: 128, echoes: 24, relays: 40, rockets: 61 },
  },
  {
    id: 'p3', authorHandle: 'nova_paints', authorName: 'Nova', avatar: AVATARS.nova,
    time: '3 h', text: 'studies in blue. what should i paint next?', image: ART.paint2,
    galaxy: 'art', pinned: false, privacy: 'Cosmos',
    counts: { stars: 302, echoes: 55, relays: 88, rockets: 120 },
  },
  {
    id: 'p4', authorHandle: 'lyra.exe', authorName: 'Lyra', avatar: AVATARS.lyra,
    time: '5 h', text: 'late night render finally done. worth the burnt eyes.', image: ART.digital,
    galaxy: 'graphic design', pinned: false, privacy: 'Public Galaxy',
    counts: { stars: 91, echoes: 12, relays: 20, rockets: 33 },
  },
  {
    id: 'p5', authorHandle: 'orion_writes', authorName: 'Orion', avatar: AVATARS.orion,
    time: '8 h', text: 'we are all just stardust trying to remember the sky.', image: null,
    galaxy: 'poetry', pinned: false, privacy: 'Public Galaxy',
    counts: { stars: 540, echoes: 77, relays: 210, rockets: 300 },
  },
];

export const FRIENDS = [
  { handle: 'dev_cosmo', name: 'Cosmo', avatar: AVATARS.cosmo, orbiting: true },
  { handle: 'nova_paints', name: 'Nova', avatar: AVATARS.nova, orbiting: true },
  { handle: 'lyra.exe', name: 'Lyra', avatar: AVATARS.lyra, orbiting: false },
  { handle: 'orion_writes', name: 'Orion', avatar: AVATARS.orion, orbiting: true },
  { handle: 'vega_lens', name: 'Vega', avatar: AVATARS.vega, orbiting: false },
];

export const GALAXIES = [
  { name: 'art', members: '128k', color: '#ff5bd1' },
  { name: 'graphic design', members: '92k', color: '#8b7ce8' },
  { name: 'photography', members: '210k', color: '#57d8e6' },
  { name: 'poetry', members: '44k', color: '#c9a24b' },
  { name: 'music', members: '305k', color: '#ff9de0' },
  { name: 'astronomy', members: '76k', color: '#7b9dff' },
];

export const SCREEN_TIME = {
  usedMinutes: 135,
  limitMinutes: 240,
  resetIn: '09h 45m',
  remindBefore: '15 minutes before limit',
};
